/*
 追従ヘッダーがある地点から背景色を変更
 */
module.exports = function(scene){
    require('TweenMax');
    var $globalHeader = $('#js-globalHeader');

    scene.on('enter', function() {
        //console.log('enter');
        $globalHeader.addClass('is-fixed');
    });

    scene.on('leave', function() {
        //console.log('leave');
        $globalHeader.removeClass('is-fixed');
    });
};



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/module/scene-globalHeader.js
 **/